import { useMedplum } from '@medplum/react'
import { useAppFlags } from '@/hooks/useAppFlags'
import { hasLdClientId, useLdIdentifiedKey } from '@/hooks/useLdIdentified'

/**
 * Whether the signed-in user may open Population Health: the LaunchDarkly flag
 * `population-health` (camel-cased `populationHealth`), targeted per user by their Medplum
 * profile id or name. Off unless the flag serves true.
 *
 * `undefined` until LaunchDarkly has identified this user — before that the flags are the
 * anonymous pre-login context's and would read as off. With no LaunchDarkly client id (local
 * dev) the flags come from `localFeatureFlags.local.ts` and are ready at once.
 *
 * This hides the page; it is not an access control. The population endpoints show only the
 * patients the caller may see in Medplum regardless (docs/POPULATION.md).
 */
export function usePopulationHealthAccess(): boolean | undefined {
  const { populationHealth } = useAppFlags<{ populationHealth?: boolean }>()
  const profileId = useMedplum().getProfile()?.id
  const identifiedKey = useLdIdentifiedKey()
  const ready = !hasLdClientId || (profileId !== undefined && identifiedKey === profileId)
  return ready ? populationHealth === true : undefined
}
